import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesService } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { OriginType } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-companies-origin-dialog',
  templateUrl: './companies-origin-dialog.component.html',
  styleUrls: ['./companies-origin-dialog.component.scss'],
})
export class CompaniesOriginDialogComponent {
  company_id: string;
  company_origin: string;
  set_origin_form_group: FormGroup = this.form_service.set_origin_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_company_edit_running: boolean = false;

  loans: OriginType = OriginType.ORIGIN_LOANS;
  mtp: OriginType = OriginType.ORIGIN_MTP;
  direct: OriginType = OriginType.ORIGIN_DIRECT;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesOriginDialogComponent>,
    private form_service: FormService,
    private companies_service: CompaniesService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.company_id = data.company_id;
    this.company_origin = data.company_origin;
  }

  ngOnInit(): void {
    this.set_origin_form_group.get(this.form_service.origin_label)?.setValue(this.company_origin);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.isFormValid()) {
      const origin = this.set_origin_form_group.get(this.form_service.origin_label)?.value;
      this.setOrigin(this.company_id, origin);
    }
  }

  setOrigin(company_id: string, origin: string): void {
    this.is_company_edit_running = true;
    this.companies_service.setOrigin(company_id, origin).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_company_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_company_edit_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.set_origin_form_group);
  }
}
